module.exports = __webpack_public_path__ + "static/media/insta5.de109a63.png";